import React, { FC } from 'react';
import classes from './styles/index.module.scss';
import classNames from "classnames";

type InfoContainerType = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>

export const InfoContainer: FC<InfoContainerType> = (
    { className, ...props}
) => {
    const containerClasses = classNames(className, classes.infoContainer)
    return (
        <div className={containerClasses} {...props}/>
    );
}